import Button from '@shared/components/core/button/CoreButton';
import DescriptionEditor from '@shared/components/core/field/editor/DescriptionEditor';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import { FlexPageContent, SubSectionContent } from '@shared/components/core/layouts/CommonLayoutStyles';
import SplashLoader from '@shared/components/loading/SplashLoader';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useCurrentOrgDeviceTypeEditor } from '@shared/hooks/useCurrentOrgDeviceTypeEditor';
import useCurrentOrgProjectsFetching from '@shared/hooks/useCurrentOrgProjectsFetching';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import OrgNoAccessBanner from '../../banners/OrgNoAccessBanner';
import ProjectsUpgradeBanner from '../ProjectsUpgradeBanner';
import DeviceTypeDefaultLanguageEditor from './editors/DeviceTypeDefaultLanguageEditor';
import DeviceTypeNameEditor from './editors/DeviceTypeNameEditor';
import DeviceTypeSupportFeaturesEditor from './editors/DeviceTypeSupportFeaturesEditor';
import DeviceTypeSupportsLocalesEditor from './editors/DeviceTypeSupportsLocalesEditor';
import DeviceTypeToggleEditor from './editors/DeviceTypeTogglesEditor';

// TODO ADMIN PANEL: Update custom controls after API work with locales is finished.
export default function ProjectDeviceTypePageContent() {
    const { t } = useTranslation();
    const { organizationId, deviceId } = useParams();
    const { currentOrg, canCreateAuthClients, isLoading } = useCurrentOrgDetailsFetching();
    const { currentOrgDeviceType, error, isLoading: isLoadingProject } = useCurrentOrgProjectsFetching();
    const {
        editDeviceType,
        handleInputChange,
        handleSaveWithAlerts: handleSave,
    } = useCurrentOrgDeviceTypeEditor(currentOrgDeviceType);

    if (!organizationId || !deviceId) return null;
    if (!currentOrgDeviceType || !editDeviceType || isLoading || isLoadingProject) return <SplashLoader />;
    if (!currentOrg || !canCreateAuthClients || error.device) return <OrgNoAccessBanner />;
    if (!currentOrg.isDeveloperAccess || !currentOrg.canCreateAuthClients) return <ProjectsUpgradeBanner />;

    return (
        <FlexPageContent>
            <SubSectionRow title={t('common:settings.title')} />
            <SubSectionContent>
                <DeviceTypeNameEditor
                    value={editDeviceType.name}
                    onUpdate={(field, value) => handleInputChange(field, value)}
                />
                <DescriptionEditor
                    value={editDeviceType.description}
                    onUpdate={(field, value) => handleInputChange(field, value)}
                />
                <DeviceTypeSupportFeaturesEditor editDeviceType={editDeviceType} onUpdate={handleInputChange} />
                <DeviceTypeToggleEditor editDeviceType={editDeviceType} onUpdate={handleInputChange} />
            </SubSectionContent>
            <SubSectionRow title={t('common:localization.titleShort')} />
            <SubSectionContent>
                <DeviceTypeDefaultLanguageEditor
                    value={editDeviceType.defaultLocale ?? 'en'}
                    supportsLocales={editDeviceType.supportsLocales ?? ['en']}
                    onUpdate={handleInputChange}
                />
                <DeviceTypeSupportsLocalesEditor
                    value={editDeviceType.supportsLocales ?? ['en']}
                    onUpdate={(field, value) => handleInputChange(field, value)}
                />
            </SubSectionContent>
            {/* <SubSectionRow title={t('common:organization.projects.deviceType.customControls.title')} />
            <SubSectionContent></SubSectionContent> */}
            <Button onClick={handleSave}>{t('common:save')}</Button>
        </FlexPageContent>
    );
}
